import React, { Component } from "react";

import { CSpinner } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";

class LogoutPage extends Component {
  render() {
    const { logged } = this.props.general;

    if (!logged) {
      const currentURL = window.location.href;

      let userGroup = this.props.general.active_roles.group_id;
      if (
        userGroup === 49 ||
        (userGroup === 86 && currentURL === "https://ava.educandus.com.br/")
      ) {
        window.location.replace("https://alagoas.educandus.com.br/");
      }
      return <Redirect to="/" />;
    }

    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: "100vw", height: "100vh" }}
      >
        <CSpinner size="lg" color="primary" className="mr-3" />
        <h3 className="m-0">Saindo da plataforma...</h3>
      </div>
    );
  }
}

LogoutPage.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

LogoutPage.defaultProps = {
  hideLayout: true,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);
